import * as types from "./types";

export const getNotificationsList = (data) => {
  return {
    type: types.GET_NOTIFICATIONS_LISTING,
    payload: data,
  };
};

export const setNotificationsCount = (count) => {
  return {
    type: types.SET_NOTIFICATIONS_COUNT,
    payload: count,
  };
};

export const setAllRead = (read) => {
  return {
    type: types.SET_ALL_READ,
    payload: read,
  };
};

export const setNotificationsLoading = (isLoading) => {
  return {
    type: types.SET_NOTIFICATIONS_LOADING,
    payload: isLoading,
  };
};